import useClarityIdentify from 'utils/hooks/use-clarity-identify/useClarityIdentify'

const ClarityInitializer = () => {
  useClarityIdentify()

  return null
}

export default ClarityInitializer
